import React from 'react';
import PropTypes from 'prop-types';

import {Grid, Stack, Divider, Box, Typography} from 'views/components';

import {Translate} from 'views/module';
import moment from 'moment';

import InterviewCard from './InterviewCard';

const Interviews = (props) => {
  const {caregiverInterviews = []} = props;

  // Sort interviews by date (newest first)
  const sortedInterviews = [...caregiverInterviews].sort((a, b) => {
    return moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf();
  });

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Divider/>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2} justifyContent='space-between' alignItems={{md: 'center'}}>
          <Grid item xs={12}>
            <Stack direction='row' >
              <Stack spacing={2} width={1}>
                <Stack>
                  <Box pb={1}>
                    {
                      sortedInterviews.length === 0 &&
                      <Typography color="text.secondary" align="center">
                        <Translate expression="caregiver.CaregiverDetail.Interviews.EmptyInterviews" />
                      </Typography>
                    }
                    {
                      sortedInterviews.length > 0 &&
                      sortedInterviews.map((interview) => (
                        <Box key={interview.interviewRn} px={2}>
                          <InterviewCard
                            interview={interview}
                          />
                        </Box>
                      ))
                    }
                  </Box>
                </Stack>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

Interviews.propTypes = {
  caregiverInterviews: PropTypes.array,
};

export default React.memo(Interviews);
